import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

import { type OtButtonVariant } from '@1trading/design-system';
import { inject, ref, type PropType } from 'vue';

import { BalanceDisplayType, balanceService } from '@exchange/libs/balances/service/src';


export default /*#__PURE__*/_defineComponent({
  __name: 'PrivacyButton',
  props: {
  buttonVariant: { type: String as PropType<OtButtonVariant>, default: 'clear' },
},
  setup(__props) {



const { setBalanceDisplayType } = balanceService;

const balanceMasked = inject('balanceMasked', ref(false));

const onSetMasked = () => {
  setBalanceDisplayType(balanceMasked.value ? BalanceDisplayType.FIAT : BalanceDisplayType.HIDDEN);
};

return (_ctx: any,_cache: any) => {
  const _component_ot_icon = _resolveComponent("ot-icon")!
  const _component_x_button = _resolveComponent("x-button")!

  return (_openBlock(), _createBlock(_component_x_button, {
    class: "privacy-button",
    variant: __props.buttonVariant,
    size: "2xs",
    onClick: onSetMasked
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_component_ot_icon, {
        key: String(_unref(balanceMasked)),
        class: "privacy-button__icon",
        name: _unref(balanceMasked) ? 'eye-slash' : 'eye'
      }, null, 8, ["name"]))
    ]),
    _: 1
  }, 8, ["variant"]))
}
}

})